import { useEffect } from 'react';

/**
 * Donne à l'onglet du navigateur un titre propre à la page, et rend le titre
 * d'origine en la quittant.
 *
 * Pourquoi (29/09/2026) : le titre de l'application est « MediPocket » pour
 * tout le site, onglets patients compris. Or une fiche remise à un patient ne
 * vient pas d'un logiciel, elle vient de son médecin — et le titre se lit dans
 * la barre d'onglets, dans l'historique et dans la feuille de partage du
 * téléphone. Les pages ouvertes par un patient posent donc le leur.
 */
export function useTitreOnglet(titre) {
  useEffect(() => {
    if (!titre) return undefined;
    const precedent = document.title;
    document.title = titre;
    return () => { document.title = precedent; };
  }, [titre]);
}

export default useTitreOnglet;
